export default (settings: any) => settings['extendedTableView'] * 0.5
